import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledDealflowEntityProfilePage = styled(Page)`
  .Profile {
    &:not(.Profile-isEditing, .Profile-showToc) {
      padding-top: 0;
    }
  }
  
  ${ComponentStyles}
`;

StyledDealflowEntityProfilePage.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntityProfilePage;
